/*** IMPORTS FROM imports-loader ***/
var jQuery = require("jquery");
var $ = require("jquery");

import 'aisztheme';

import React from 'react';
import CSSModules from 'react-css-modules';
import { connect } from 'react-redux';
import { Link } from 'react-router';
import { routerActions } from 'react-router-redux';
import { injectIntl } from 'react-intl';
import {
  Panel,
  Form,
  FormGroup,
  FormControl,
  Modal,
  Button,
} from 'react-bootstrap';
import { createCharge, rechgCard } from 'loraapi/Billing';
import Toolbar from 'loracoms/Toolbar';
import ActionButton from 'loracoms/ActionButton';
import PageLoading from 'loracoms/PageLoading';
import ShowIf from 'loracoms/ShowIf';
import IntlMsg from 'lorautils/intl/IntlMsg';
import billingActions from 'loraactions/billing';
import orgActions from 'loraactions/org';
import { billPaidSelector } from './selectors';
import styles from './styles.scss';
import imgAlipay from './images/alipay.png';
import imgWechatZh from './images/wechatpay_340x120_zh.svg';
import imgWechatEn from './images/wechatpay_340x120_en.svg';
import imgWechatPhone from './images/wechatpay_phone.png';
import imgAlipayIcon from './images/alipay_icon.svg';
import recharge from './images/recharge.svg';


const propTypes = {
  intl: React.PropTypes.object.isRequired,
  pushState: React.PropTypes.func.isRequired,
  plan: React.PropTypes.object.isRequired,
  getBalog: React.PropTypes.func.isRequired,
  billPaid: React.PropTypes.bool.isRequired,
  getBasic: React.PropTypes.func.isRequired,
  getPlan: React.PropTypes.func.isRequired,
  locale: React.PropTypes.string.isRequired,
};

class Recharge extends React.Component {

  constructor(props) {
    super(props);
    this.state = {
      plan: props.plan,
      billPaid: props.billPaid,
      locale: props.locale,
      errSeen: false,
      amount: '',
      method: 'alipay',
      status: 'ready',
      valid: true,
      view: 'main',
      remaining: 120,
      showRechgCardModal: false,
      rechgCardStatus: '',
    };

    this.handleChangeAmount = this.handleChangeAmount.bind(this);
    this.handleChangeMethod = this.handleChangeMethod.bind(this);
    this.handleAlipayCharge = this.handleAlipayCharge.bind(this);
    this.handleWechatCharge = this.handleWechatCharge.bind(this);
    this.handleSubmitRecharge = this.handleSubmitRecharge.bind(this);
    this.handleReloadWechatCharge = this.handleReloadWechatCharge.bind(this);
    this.rechgAgain = this.rechgAgain.bind(this);
    this.intlMsg = new IntlMsg(props.intl, 'billing.recharge');
  }

  componentWillReceiveProps(nextProps) {
    const { plan, billPaid, locale } = nextProps;
    if (plan !== this.props.plan) {
      this.setState({ plan });
    }
    if (locale !== this.props.locale) {
      this.setState({ locale });
    }

    if (billPaid) {
      this.setState({ billPaid });
    }
  }

  componentWillUnmount() {
    if (this.watchTimeout) {
      clearTimeout(this.watchTimeout);
    }
    if (this.countDownTimeout) {
      clearTimeout(this.countDownTimeout);
    }
    const { billPaid } = this.state;
    if (billPaid) {
      const { getBasic, getPlan } = this.props;
      getBasic();
      getPlan();
    }
  }

  validateAmount(amount) {
    const { plan: { data: plan }, method } = this.state;
    if (method === 'rechgcard') {
      return true;
    }
    let valid = true;
    let error = null;
    if (amount.length === '') {
      valid = false;
      error = this.intlMsg.msg('errmsg.absent');
    } else if (amount.search(/^\d+(\.\d{0,2})?$/)) {
      valid = false;
      error = this.intlMsg.msg('errmsg.malformed');
    } else if (+amount <= 0) {
      valid = false;
      error = this.intlMsg.msg('errmsg.negative');
    } else if (+amount >= 100000) {
      valid = false;
      error = this.intlMsg.msg('errmsg.toolarge');
    } else if (plan.tier !== 3 && +amount < 200) {
      valid = false;
      error = this.intlMsg.msg('errmsg.toolow');
    }
    this.setState({
      valid,
      error,
    });
    if (!valid) {
      this.setState({
        errSeen: true,
      });
    }
    return valid;
  }

  handleChangeAmount(e) {
    const amount = _.trim(e.target.value);
    if (this.state.errSeen) {
      this.validateAmount(amount);
    }
    this.setState({ amount });
  }

  handleSubmitRecharge(e) {
    e.preventDefault();
    const { method } = this.state;
    let { amount } = this.state;
    if (method === 'rechgcard') {
      if (amount.length === 0) {
        return;
      }
      this.setState({ showRechgCardModal: true, rechgCardStatus: 'rechging' });
      rechgCard(amount)
        .then(() => {
          this.setState({ rechgCardStatus: 'success', billPaid: true });
        })
        .catch((err) => {
          if (err.errmsg) {
            this.setState({ rechgCardStatus: err.errmsg });
          }
        });
    } else {
      if (!this.validateAmount(amount)) {
        return;
      }

      this.setState({ status: 'loading', billPaid: false });

      if (method === 'alipay') {
        this.setState({
          showConfirmModal: true,
        });
        this.newWindow = window.open(`${window.location.origin}/static/loading.html`, '_blank');
      }

      amount = Number(amount);
      createCharge(
        'recharge',
        method,
        amount,
        null,
      ).then((resp) => {
        if (method === 'alipay') {
          this.handleAlipayCharge(resp.body);
        } else if (method === 'wechat') {
          this.handleWechatCharge(resp.body);
        }
      }).catch(() => {
        this.setState({
          status: 'failed',
        });
      });
    }
  }

  handleAlipayCharge(charge) {
    const params = $.param(charge);
    this.setState({
      status: 'ready',
    });
    const url = `https://mapi.alipay.com/gateway.do?${params}`;
    this.newWindow.location.href = url;
  }

  startWatchBill(billId) {
    const { getBalog } = this.props;
    const that = this;

    const g = () => {
      getBalog(billId);
      const { billPaid, remaining } = that.state;
      if (remaining > 0 && !billPaid) {
        that.watchTimeout = setTimeout(g, 3000);
      }
    };

    this.watchTimeout = setTimeout(g, 3000);
  }

  startCountDown() {
    const that = this;
    const g = () => {
      const { remaining, billPaid } = that.state;
      if (remaining > 0 && !billPaid) {
        that.setState({ remaining: remaining - 1 });
        this.countDownTimeout = setTimeout(g, 1000);
      }
    };
    this.countDownTimeout = setTimeout(g, 1000);
  }

  handleWechatCharge(charge) {
    const retCode = charge.return_code;
    const resCode = charge.result_code;
    const qrCode = charge.qr_code;
    if (retCode === 'SUCCESS' || resCode === 'SUCCESS') {
      this.setState({
        view: 'wechatpay',
        qrCode,
        charge,
        status: 'ready',
        remaining: 120,
      });
      this.startWatchBill(charge.bill_id);
      this.startCountDown();
    } else {
      this.setState({
        status: 'failed',
      });
    }
  }

  handleReloadWechatCharge() {
    const { charge } = this.state;
    this.handleWechatCharge(charge);
  }

  handleChangeMethod(method) {
    this.setState({ method });
    if (method === 'rechgcard') {
      this.setState({ valid: true, amount: '' });
    }
  }

  rechgAgain() {
    this.setState({ showRechgCardModal: false, amount: '' });
  }

  renderToolbar() {
    const { view } = this.state;
    let breadcrumb;
    if (view === 'main') {
      breadcrumb = [{
        content: this.intlMsg.msg('billing', 'billing.breadcrumb'),
        onClick: () => this.props.pushState('/billing'),
      }, {
        content: this.intlMsg.msg('recharge', 'billing.breadcrumb'),
        active: true,
      }];
    } else {
      breadcrumb = [{
        content: this.intlMsg.msg('billing', 'billing.breadcrumb'),
        onClick: () => this.props.pushState('/billing'),
      }, {
        content: this.intlMsg.msg('recharge', 'billing.breadcrumb'),
        onClick: () => this.setState({ view: 'main' }),
      }, {
        content: this.intlMsg.msg('recharge.wechat', 'billing.breadcrumb'),
        active: true,
      }];
    }

    return <Toolbar breadcrumb={breadcrumb} />;
  }

  renderMainView() {
    const { error, valid, method, amount } = this.state;
    let errmsg = null;
    if (!valid) {
      errmsg = (
        <div styleName="error">
          <i className="fa fa-exclamation-triangle" aria-hidden="true" />
          {' '}
          {error}
        </div>
      );
    }

    let icon;
    let loadingLabel;
    let placeholder;
    if (method === 'alipay') {
      icon = <img src={imgAlipayIcon} alt="" />;
      loadingLabel = this.intlMsg.msg('form.alipay.redirecting');
      placeholder = this.intlMsg.msg('form.placeholder');
    } else if (method === 'wechat') {
      icon = <i className="fa fa-weixin" />;
      loadingLabel = this.intlMsg.msg('form.wechat.loading');
      placeholder = this.intlMsg.msg('form.placeholder');
    } else if (method === 'rechgcard') {
      icon = <i className="fa fa-credit-card" />;
      placeholder = this.intlMsg.msg('form.placeholdercard');
    }

    return (
      <div>
        <div>
          { this.renderToolbar() }
        </div>
        <Panel bsStyle="aisz-white">
          <div styleName="methods">
            <ul className="list-inline">
              <li>
                <Link
                  styleName={`method ${method === 'alipay' ? 'active' : ''}`}
                  onClick={() => this.handleChangeMethod('alipay')}
                >
                  <img alt="AliPay" src={imgAlipay} className="img-responsive" />
                </Link>
              </li>
              <li>
                <Link
                  styleName={`method ${method === 'wechat' ? 'active' : ''}`}
                  onClick={() => this.handleChangeMethod('wechat')}
                >
                  <img alt="WeChat Pay" src={this.props.intl.locale === 'zh' ? imgWechatZh : imgWechatEn} className="img-responsive" />
                </Link>
              </li>
              <li>
                <Link
                  styleName={`method ${method === 'rechgcard' ? 'active' : ''} widthAuto clearLine`}
                  onClick={() => this.handleChangeMethod('rechgcard')}
                >
                  <img
                    alt="Recharge Card"
                    src={recharge}
                    className="img-responsive"
                    styleName="inline"
                  />
                  <span styleName="cardTxt clearLine">&nbsp;{this.intlMsg.msg('types.card')}</span>
                </Link>
              </li>
            </ul>
          </div>
          <div styleName="recharge-form">
            <Form inline onSubmit={this.handleSubmitRecharge}>
              <FormGroup validationState={valid ? undefined : 'error'}>
                <FormControl
                  bsClass="aisz-form-control"
                  placeholder={placeholder}
                  value={amount}
                  onChange={this.handleChangeAmount}
                />
              </FormGroup>
              <FormGroup>
                <ActionButton
                  type="submit"
                  icon={icon}
                  label={this.intlMsg.msg('form.submit.btn')}
                  loadingLabel={loadingLabel}
                  failedLabel={this.intlMsg.msg('form.err.submiterr')}
                  status={this.state.status}
                  onStatusReset={() => this.setState({ status: 'ready' })}
                  disabled={!valid}
                />
              </FormGroup>
            </Form>
            {errmsg}
          </div>
        </Panel>
      </div>
    );
  }

  renderQrCode() {
    const { qrCode, remaining, billPaid } = this.state;

    return (
      <div styleName="qrcode">
        <img src={`data:image/png;base64,${qrCode}`} alt="" className="img-responsive" />
        <ShowIf if={remaining <= 0}>
          <div styleName="result expired">
            {this.intlMsg.msg('wechat.qrcode.expired')}
            <br />
            <Button
              bsStyle="aisz-link"
              onClick={this.handleReloadWechatCharge}
            >
              {this.intlMsg.msg('wechat.qrcode.refresh')}{' '}
              <span className="halflings halflings-refresh" />
            </Button>
          </div>
        </ShowIf>
        <ShowIf if={billPaid}>
          <div styleName="result success">
            <span className="halflings halflings-tick" />{' '}
            {this.intlMsg.msg('wechat.qrcode.success')}
          </div>
        </ShowIf>
      </div>
    );
  }

  renderCountDown() {
    const { remaining, billPaid } = this.state;
    if (remaining <= 0 || billPaid) {
      return null;
    }
    const miniutes = Math.floor(remaining / 60);
    const seconds = remaining % 60;
    return (
      <div styleName="countdown">
        {this.intlMsg.msg('wechat.countdown.text1')}
        <span styleName="remaining">{`${miniutes}:${seconds}`}</span>
        {this.intlMsg.msg('wechat.countdown.text2')}
      </div>
    );
  }

  renderWechatPayView() {
    const { charge } = this.state;
    return (
      <div>
        <div>
          { this.renderToolbar() }
        </div>
        <div styleName="bill-info">
          <ul className="list-inline">
            <li>
              <span styleName="label">{this.intlMsg.msg('wechat.billid')}</span>
              {charge.bill_id}
            </li>
            <li>
              <span styleName="label">{this.intlMsg.msg('wechat.amount')}</span>
              <strong>{charge.amount}</strong>
            </li>
          </ul>
        </div>
        <Panel bsStyle="aisz-white">
          <div className="text-center">
            <div styleName="wechat">
              <div styleName="scan">
                {this.renderQrCode()}
                <div styleName="footer">
                  <span className="halflings halflings-qrcode" />{' '}
                  {this.intlMsg.msg('wechat.scancode')}
                </div>
                {this.renderCountDown()}
              </div>
              <div styleName="scanillu">
                <img src={imgWechatPhone} alt="" className="img-responsive" />
              </div>
            </div>
          </div>
        </Panel>
      </div>
    );
  }

  renderConfirmModal() {
    return (
      <Modal
        bsClass="aisz-modal-light"
        show={this.state.showConfirmModal}
        backdrop="static"
        onHide={() => this.setState({ showConfirmModal: false })}
      >
        <Modal.Header closeButton>
          {this.intlMsg.msg('confirmmodal.header')}
        </Modal.Header>
        <Modal.Body>
          <div className="text-center">
            <p>
              {this.intlMsg.msg('confirmmodal.body')}
            </p>
            <Button
              bsStyle="aisz-primary"
              onClick={() => this.setState({ showConfirmModal: false })}
            >
              {this.intlMsg.msg('confirmmodal.button.redo')}{' '}
              <span className="halflings halflings-repeat" />
            </Button>
            {' '}
            <Button
              bsStyle="aisz-success"
              onClick={() => this.props.pushState('/billing')}
            >
              {this.intlMsg.msg('confirmmodal.button.complete')}{' '}
              <span className="halflings halflings-tick" />
            </Button>
          </div>
        </Modal.Body>
      </Modal>
    );
  }
  render() {
    const { plan, view } = this.state;
    let content = null;

    if (plan.status !== 'success') {
      content = <PageLoading />;
    } else if (view === 'main') {
      content = this.renderMainView();
    } else if (view === 'wechatpay') {
      content = this.renderWechatPayView();
    }

    return (
      <div styleName="wrapper">
        { content }
        <div>
          {this.renderConfirmModal()}
        </div>
        <Modal
          bsClass="aisz-modal-light"
          show={this.state.showRechgCardModal}
          backdrop="static"
          onHide={() => this.setState({ showRechgCardModal: false })}
        >
          <Modal.Dialog>
            <div className={`clearfix ${styles.cancelHeader}`}>
              <Link
                className="fa fa-times pull-right"
                onClick={this.rechgAgain}
              />
            </div>
            <Modal.Body className="text-center">
              <ShowIf if={this.state.rechgCardStatus === 'rechging'}>
                <div>
                  <i className="fa fa-spin fa-spinner fa-3x" styleName="cardLoading" />
                  <p styleName="cardLoading">{this.intlMsg.msg('rechgcard.rechging')}</p>
                </div>
              </ShowIf>
              <ShowIf if={this.state.rechgCardStatus === 'success'}>
                <div>
                  <div>
                    <i className="fa fa-check fa-3x text-success" />
                    <p styleName="cardTxt">{this.intlMsg.msg('confirmmodal.button.complete')}</p>
                  </div>
                  <div>
                    <Button
                      bsStyle="aisz-primary"
                      onClick={this.rechgAgain}
                    >
                      {this.intlMsg.msg('rechgcard.continue')}&nbsp;
                      <span className="halflings halflings-repeat" />
                    </Button>
                    &nbsp;
                    <Button
                      bsStyle="aisz-success"
                      onClick={() => this.props.pushState('/billing')}
                    >
                      {this.intlMsg.msg('rechgcard.complete')}&nbsp;
                      <span className="halflings halflings-tick" />
                    </Button>
                  </div>
                </div>
              </ShowIf>
              <ShowIf if={this.state.rechgCardStatus !== 'success'}>
                <div>
                  <i className="fa fa-exclamation-circle fa-3x text-danger" />
                  <ShowIf if={this.state.rechgCardStatus === 'Invalid RchgCard ID'}>
                    <p styleName="cardTxt">{this.intlMsg.msg('rechgcard.errcode')}</p>
                  </ShowIf>
                  <ShowIf if={this.state.rechgCardStatus === 'Applied'}>
                    <p styleName="cardTxt">{this.intlMsg.msg('rechgcard.errcodeused')}</p>
                  </ShowIf>
                  <ShowIf if={this.state.rechgCardStatus === 'ErrExpired'}>
                    <p styleName="cardTxt">{this.intlMsg.msg('rechgcard.errexpired')}</p>
                  </ShowIf>
                  <div>
                    <Button
                      bsStyle="aisz-primary"
                      onClick={this.rechgAgain}
                    >
                      {this.intlMsg.msg('rechgcard.tryagain')}&nbsp;
                      <span className="halflings halflings-repeat" />
                    </Button>
                  </div>
                </div>
              </ShowIf>
            </Modal.Body>
          </Modal.Dialog>
        </Modal>
      </div>
    );
  }
}

Recharge.propTypes = propTypes;

const mapStateToProps = state => ({
  plan: state.billing.plan,
  billPaid: billPaidSelector(state),
  locale: state.intl.locale,
});

const mapDispatchToProps = {
  pushState: routerActions.push,
  getBalog: billingActions.getBalog,
  getBasic: orgActions.basic,
  getPlan: billingActions.plan,
};

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(injectIntl(CSSModules(Recharge, styles, { allowMultiple: true })));




// WEBPACK FOOTER //
// ./src/containers/Billing/Recharge/index.jsx